const passives = {}

passives["critical"] = {
    "title": "Critical",
    "color": "red",
    "description": ({stage, unit}) => {
        return "2x every third attack."
    },
    "powerboost": ({stage, unit}) => {
        if(unit.attacktally > 0
        && (unit.attacktally + 0) % 4 == 0) {
            return (unit.power || 0) + (unit.equippedItem?.power || 0)
        }
    }
}

passives["nimble"] = {
    "title": "Nimble",
    "color": "red",
    "description": ({stage, unit}) => {
        return "Dodge every 3rd attack."
    },
    "propertyboost": ({stage, unit}) => {
        if((unit.attackedtally + 0) % 3 == 0) {
            return "dodging"
        }
    }
}

export default passives
